import {
  diasParaNetoConstruccion,
  resolverNetoPorDiaConstruccion,
} from '../services/calculoRemuneracionConstruccionCivil';

function isoFecha(valor) {
  if (!valor) return null;
  const s = String(valor).split('T')[0].split(' ')[0].slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return null;
  const anio = Number(s.slice(0, 4));
  if (anio < 1900 || anio > 2100) return null;
  return s;
}

export function esPlanillaModalidadConstruccion(planilla) {
  return String(planilla?.modalidad_planilla || '').toLowerCase().includes('construccion');
}

/**
 * Periodo de cálculo CONSU: override por trabajador recortado al rango de la planilla.
 * Solo aplica si la planilla es modalidad construcción.
 */
export function resolverPeriodoCalculoConsu({
  planilla = {},
  fechaCalculoDesde = null,
  fechaCalculoHasta = null,
} = {}) {
  const planillaInicio = isoFecha(planilla.fecha_inicio);
  const planillaFin = isoFecha(planilla.fecha_fin);
  const base = {
    fechaInicio: planillaInicio,
    fechaFin: planillaFin,
    override: false,
  };

  if (!esPlanillaModalidadConstruccion(planilla)) {
    return base;
  }

  const crudoDesde = isoFecha(fechaCalculoDesde);
  const crudoHasta = isoFecha(fechaCalculoHasta);
  let desde = crudoDesde || planillaInicio;
  let hasta = crudoHasta || planillaFin;

  if (planillaInicio && desde && desde < planillaInicio) desde = planillaInicio;
  if (planillaFin && desde && desde > planillaFin) desde = planillaFin;
  if (planillaFin && hasta && hasta > planillaFin) hasta = planillaFin;
  if (planillaInicio && hasta && hasta < planillaInicio) hasta = planillaInicio;

  if (desde && hasta && desde > hasta) {
    return base;
  }

  const override = Boolean(
    (crudoDesde && crudoDesde !== planillaInicio)
    || (crudoHasta && crudoHasta !== planillaFin)
  );

  return {
    fechaInicio: desde,
    fechaFin: hasta,
    override,
  };
}

function contarAsistenciasEnRango(tareos, desde, hasta) {
  return (Array.isArray(tareos) ? tareos : []).filter((t) => {
    const f = isoFecha(t?.fecha);
    if (!f) return false;
    if (desde && f < desde) return false;
    if (hasta && f > hasta) return false;
    const tipo = String(t?.tipo_evento || '').toLowerCase();
    return tipo.includes('asist') || tipo === 'tardanza' || tipo === 'trabajo_normal';
  }).length;
}

/**
 * Neto por día para boleta CONSU: usa los días del rango personalizado, no el tareo completo.
 */
export function resolverNetoPorDiaBoletaConsu(empleado, planilla) {
  const calc = empleado?.calculoConstruccionCivil || {};
  const periodo = resolverPeriodoCalculoConsu({
    planilla,
    fechaCalculoDesde: empleado?.fecha_calculo_desde,
    fechaCalculoHasta: empleado?.fecha_calculo_hasta,
  });
  let dias = diasParaNetoConstruccion({
    resumen: calc.resumen,
    detalleDias: calc.detalleDias,
    diasTrabajadosTareo: 0,
  });
  if (dias <= 0 && periodo.override) {
    const tareos = empleado?.tareosEmpleadoFiltrados || empleado?.tareosEmpleado || [];
    dias = contarAsistenciasEnRango(tareos, periodo.fechaInicio, periodo.fechaFin) || 1;
  }
  if (dias <= 0) {
    dias = Number(empleado?.totales?.diasNeto) || 0;
  }
  if (dias <= 0) return null;
  const neto = Number(empleado?.totales?.netoAPagar) || 0;
  const extra = resolverNetoPorDiaConstruccion({
    neto,
    diasAsistencia: dias,
  });
  return {
    ...extra,
    override: Boolean(periodo.override),
    fechaInicio: periodo.fechaInicio,
    fechaFin: periodo.fechaFin,
  };
}
